import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["placeholder", "value", "maxlength"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { ref } from 'vue';
import { SpriteIcons } from '@/user/components/common/';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SmallBorderSearch',
    props: {
        modelValue: { default: '' },
        className: { default: undefined },
        errorMessage: { default: undefined },
        placeholder: { default: 'Placeholder' },
        maxlength: { default: undefined }
    },
    emits: ["update:modelValue", "search", "clear"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputRef = ref();
        const input = tv({
            slots: {
                inputItem: clsx('j-search-text-input peer w-full text-gray-900 placeholder:text-gray-400 read-only:text-gray-400 read-only:text-gray-900 focus:outline-none disabled:text-gray-400', 'text-body-5', 'desktop:text-body-4'),
                inputCover: clsx('border-gray-250 rounded-8 has-focus:border-gray-700 flex items-center border bg-gray-100 px-16 py-2 hover:border-gray-700', 'min-h-42', 'desktop:py-10 desktop:min-h-48'),
                removeButton: clsx('j-search-text-remove peer:not(:placeholder-shown):block h-20 w-20 shrink-0 text-gray-400 hover:text-gray-700 peer-placeholder-shown:hidden', ''),
                searchButton: clsx('ml-4 h-24 w-24 shrink-0'),
                errorMessageText: clsx('c-inp-error-message text-body-6 mt-4', '', '', ''),
            },
            variants: {},
        });
        const { inputItem, inputCover, removeButton, searchButton, errorMessageText } = input();
        const handleInput = (event) => {
            const target = event.target;
            emit('update:modelValue', target.value);
        };
        const handleClear = () => {
            emit('update:modelValue', '');
            emit('clear');
            // input 요소에 직접 포커스를 주어 상태를 업데이트
            if (inputRef.value) {
                inputRef.value.value = '';
                inputRef.value.focus();
            }
        };
        const handleSearch = () => {
            emit('search');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: _normalizeClass([_unref(inputCover)(), props.errorMessage ? 'c-inp-error' : '', props.className])
                }, [
                    _createElementVNode("input", {
                        ref_key: "inputRef",
                        ref: inputRef,
                        class: _normalizeClass(_unref(inputItem)()),
                        placeholder: props.placeholder,
                        type: "text",
                        value: props.modelValue,
                        maxlength: props.maxlength,
                        onInput: handleInput,
                        onKeyup: _withKeys(handleSearch, ["enter"])
                    }, null, 42, _hoisted_1),
                    _createElementVNode("button", {
                        class: _normalizeClass(_unref(removeButton)()),
                        type: "button",
                        onClick: handleClear
                    }, [
                        _createVNode(_unref(SpriteIcons), { name: "close-circle" }),
                        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Remove", -1))
                    ], 2),
                    _createElementVNode("button", {
                        class: _normalizeClass(_unref(searchButton)()),
                        type: "submit",
                        onClick: _withModifiers(handleSearch, ["prevent"])
                    }, [
                        _createVNode(_unref(SpriteIcons), { name: "search" }),
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "sr-only" }, "Search", -1))
                    ], 2)
                ], 2),
                (props.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(_unref(errorMessageText)())
                    }, _toDisplayString(props.errorMessage), 3))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
